import {
  ItemSelectV2,
  ItemSelectV2ComponentProps,
} from '@knowledge/common/components/ItemSelectV2';
import useModal from 'hooks/useModal';
import { ReactNode, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

function useItemSelectModal() {
  return useModal<Omit<ItemSelectV2ComponentProps, 'visible'>>();
}

export const ItemSelectContext = createNamedContext<ReturnType<typeof useItemSelectModal> | null>(
  'ItemSelectContext',
  null,
);

export function useItemSelectContext() {
  const value = useContext(ItemSelectContext);

  if (!value) {
    throw new Error(
      'useItemSelectContext should be used in context of a ItemSelectProvider component',
    );
  }

  return value;
}

export function ItemSelectProvider({ children }: { children: ReactNode }) {
  const modal = useItemSelectModal();

  const { visible, hide, meta } = modal;

  const itemSelect = meta && (
    <ItemSelectV2
      {...meta}
      visible={visible}
      onCancel={() => {
        hide();
        meta.onCancel?.();
      }}
    />
  );

  return (
    <ItemSelectContext.Provider value={modal}>
      {children}
      {itemSelect}
    </ItemSelectContext.Provider>
  );
}
